import { render, staticRenderFns } from "./Dependents.vue?vue&type=template&id=c2be5a44"
import script from "./Dependents.vue?vue&type=script&lang=ts"
export * from "./Dependents.vue?vue&type=script&lang=ts"
import style0 from "./Dependents.vue?vue&type=style&index=0&id=c2be5a44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports